import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { X, Link2 } from 'lucide-react';

interface OSContextBadgeProps {
  osNumero?: number | string | null;
  osId: string;
  onClear: () => void;
}

/**
 * OSContextBadge — sinaliza quando o Portal de Execução está filtrando por uma OS.
 * Source-of-truth: ?os_id na URL (este componente não armazena estado).
 */
export const OSContextBadge: React.FC<OSContextBadgeProps> = ({ osNumero, osId, onClear }) => {
  const label = osNumero != null
    ? `Filtrando por OS-${String(osNumero).padStart(3, '0')}`
    : `Filtrando por OS ${osId.slice(0, 8)}`;
  return (
    <div className="flex items-center gap-2 rounded-lg border border-primary/30 bg-primary/5 px-3 py-2">
      <Link2 className="h-4 w-4 text-primary" />
      <Badge variant="info" className="font-medium">{label}</Badge>
      <span className="text-xs text-muted-foreground">
        Execuções vinculadas a esta Ordem de Serviço.
      </span>
      <div className="flex-1" />
      <Button size="sm" variant="ghost" className="h-7 gap-1" onClick={onClear}>
        <X className="h-3.5 w-3.5" /> Limpar filtro
      </Button>
    </div>
  );
};

export default OSContextBadge;
